module.exports = __webpack_public_path__ + "static/media/tom_english_ai_logo.3336c3f5.jpeg";